import { render } from "./Units.vue?vue&type=template&id=719c9505&scoped=true"
import script from "./Units.vue?vue&type=script&lang=js"
export * from "./Units.vue?vue&type=script&lang=js"

import "./Units.vue?vue&type=style&index=0&id=719c9505&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-719c9505"]])

export default __exports__